import React from 'react'
import { PageTitle } from '_metronic/layout/core'

import LogoInput from 'Presentation/Components/LogoInput'
import FormGenerator from 'Presentation/Components/Form/FormGenerator'
import Select from 'react-select'
import DatePicker from 'react-datepicker'

import useViewModel from './ViewModel'
import moment from 'moment'
import { isMobileDevice } from '_metronic/assets/ts/_utils'

//////////
// View //
//////////

const MarketplaceCouponFormView: React.FC = () => {
	const {
		pageTitle,
		couponTypeOptions,
		formState,
		formError,
		onChangeFormState,
		onCancel,
		onSubmit,
	} = useViewModel()

	return (
		<ViewPageTitle pageTitle={pageTitle}>
			<div className="row gy-5">
				<div className="col-12 col-lg-8">
					<div className="card border-1px border-kumopack-grey-200">
						<div className="card-header">
							<div className="card-title fw-bolder flex-column">
								สร้างคูปองส่วนลด
								<div className="fw-normal text-kumopack-grey-600 d-block fs-7">
									Update your photo and personal details here.
								</div>
							</div>
						</div>
						<div className="card-body">
							<FormGenerator
								formKey="title"
								inputType="plain"
								label="ชื่อเรียกคูปองส่วนลด"
								additionalLabelCom={<span className="required" />}
								placeholder=""
								containerClassName="mb-5 mt-10"
								isHorizontal={!isMobileDevice()}
								value={formState.title}
								onChange={e => onChangeFormState('title', e.target.value)}
								isShowValid={formError?.title !== undefined}
								additionalComInput={
									formError?.title ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{formError?.title}</div>
										</div>
									) : undefined
								}
							/>

							<div className={`mb-5 d-flex flex-column flex-xl-row align-items-center`}>
								<label
									className={`form-label col-12 col-xl-3 mb-0 mb-5 mb-xl-0`}
									data-testid="form-input-label-component">
									<span>
										ประเภทคูปอง <span className="required"></span>
									</span>
								</label>

								<div className="col-12 col-xl-9">
									<Select
										isClearable
										isSearchable={false}
										isMulti={false}
										styles={{
											control: provided => ({
												...provided,
												minHeight: 0,
												height: 43.56,
												borderRadius: '0.475rem',
												borderColor: formError?.type ? '#f1416c' : '#e1e3ea',
											}),
										}}
										components={{
											IndicatorSeparator: () => null,
										}}
										options={couponTypeOptions}
										value={
											couponTypeOptions.find(option => option.value === formState.type) || null
										}
										onChange={val => onChangeFormState('type', val)}
										placeholder="เลือกประเภทคูปอง"
									/>
								</div>
							</div>

							<FormGenerator
								formKey="value"
								inputType="plain"
								label="มูลค่าคูปอง"
								additionalLabelCom={<span className="required" />}
								placeholder=""
								containerClassName="mb-5 mt-10"
								isHorizontal={!isMobileDevice()}
								value={formState.value}
								onChange={e => onChangeFormState('value', e.target.value)}
								tooltip='กรุณากรอกมูลค่าของคูปอง ถ้าเป็นเปอร์เซ็นต์ให้ใส่เป็นตัวเลขเท่านั้น ไม่ต้องใส่เครื่องหมาย "%" หรือ "THB" หรือ "฿" หรือ "บาท" หรือ "Baht"'
								isShowValid={formError?.value !== undefined}
								additionalComInput={
									formError?.value ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{formError?.value}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="code"
								inputType="plain"
								label="รหัสคูปองส่วนลด"
								additionalLabelCom={<span className="required" />}
								placeholder=""
								containerClassName="mb-5 mt-10"
								isHorizontal={!isMobileDevice()}
								value={formState.code}
								onChange={e => onChangeFormState('code', e.target.value)}
								tooltip="ห้ามมีช่องว่าง อักขระพิเศษ และ ต้องเป็นตัวอักษรภาษาอังกฤษเท่านั้น"
								isShowValid={formError?.code !== undefined}
								additionalComInput={
									formError?.code ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{formError?.code}</div>
										</div>
									) : undefined
								}
							/>

							<FormGenerator
								formKey="amount"
								inputType="plain"
								label="จำนวนคูปองที่ใช้ได้"
								additionalLabelCom={<span className="required" />}
								placeholder=""
								containerClassName="mb-5 mt-10"
								isHorizontal={!isMobileDevice()}
								value={formState.amount}
								onChange={e => onChangeFormState('amount', e.target.value)}
								tooltip="จำนวนคูปองที่สามารถใช้ได้"
								isShowValid={formError?.amount !== undefined}
								additionalComInput={
									formError?.amount ? (
										<div className="fv-plugins-message-container mt-2">
											<div className="fv-help-block">{formError?.amount}</div>
										</div>
									) : undefined
								}
							/>

							<div className={`mb-5 d-flex flex-column flex-xl-row align-items-center`}>
								<label
									className={`form-label col-12 col-xl-3 mb-0 mb-5 mb-xl-0`}
									data-testid="form-input-label-component">
									<span>
										วันเวลาที่เริ่มใช้งาน <span className="required"></span>
									</span>
								</label>

								<div className="col-12 col-xl-9">
									<DatePicker
										showPopperArrow={false}
										minDate={new Date()}
										showTimeSelect
										timeFormat="HH:mm"
										dateFormat="dd/MM/yyyy HH:mm"
										timeIntervals={15}
										selected={formState.startDate ? moment(formState.startDate).toDate() : null}
										onChange={date => onChangeFormState('startDate', date)}
										className="form-control"
									/>
								</div>
							</div>

							<div className={`mb-5 d-flex flex-column flex-xl-row align-items-center`}>
								<label
									className={`form-label col-12 col-xl-3 mb-0 mb-5 mb-xl-0`}
									data-testid="form-input-label-component">
									<span>
										วันเวลาที่หมดอายุ <span className="required"></span>
									</span>
								</label>

								<div className="col-12 col-xl-9">
									<DatePicker
										showPopperArrow={false}
										minDate={new Date()}
										showTimeSelect
										timeFormat="HH:mm"
										dateFormat="dd/MM/yyyy HH:mm"
										timeIntervals={15}
										selected={formState.endDate ? moment(formState.endDate).toDate() : null}
										onChange={date => onChangeFormState('endDate', date)}
										className="form-control"
									/>
								</div>
							</div>

							<FormGenerator
								formKey="description"
								inputType="textarea"
								label="รายละเอียด"
								placeholder=""
								containerClassName="mb-5"
								isHorizontal={!isMobileDevice()}
								value={formState.description}
								onChange={e => onChangeFormState('description', e.target.value)}
								limitCharacter={300}
							/>

							<LogoInput
								wording="รูปภาพคูปอง"
								image={formState.featurePicturePath}
								changeImage={img => onChangeFormState('featurePicturePath', img)}
							/>
						</div>
					</div>
				</div>

				<div className="col-12 col-xl-8">
					<div
						className="d-flex flex-column-reverse flex-lg-row align-items-lg-center justify-content-lg-end"
						style={{ gap: '12px' }}>
						<button
							className="btn btn-sm white-button text-kumopack-grey-900 fw-bold"
							onClick={onCancel}>
							ยกเลิก
						</button>
						<button
							className="btn btn-sm btn-kumopack-secondary-600 text-kumopack-base-white fw-bold"
							onClick={onSubmit}>
							<img src="/media/icons/kumopack/edit-05-white.svg" alt="icon" />
							บันทึกการแก้ไข
						</button>
					</div>
				</div>
			</div>

			<style>{`
				.react-datepicker {
					font-size: 1em;
				  }
				  .react-datepicker__header {
					padding-top: 0.8em;
				  }
				  .react-datepicker__month {
					margin: 0.4em 1em;
				  }
				  .react-datepicker__day-name, .react-datepicker__day {
					width: 1.9em;
					line-height: 1.9em;
					margin: 0.166em;
				  }
				  .react-datepicker__current-month {
					font-size: 1em;
				  }
				  .react-datepicker__navigation {
					top: 1em;
					line-height: 1.7em;
					border: 0.45em solid transparent;
				  }
				  
			`}</style>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children?: React.ReactNode; pageTitle: string }> = ({
	children,
	pageTitle,
}) => {
	return (
		<React.Fragment>
			<PageTitle
				breadcrumbs={[
					{
						title: 'Marketplace',
						path: '/marketplace',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Coupons',
						path: '/marketplace/coupons',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Form',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				{pageTitle}
			</PageTitle>

			{children}
		</React.Fragment>
	)
}

export default MarketplaceCouponFormView
